import { data } from "./data.js";
import { jsx } from "react/jsx-runtime";
import { Animation } from "../animation/animation.js";
import { loaderStyles } from "./loader.styles.js";
import "lottie-react";
function Loader({ size = "md", center = true }) {
  const sizes = {
    xs: 20,
    sm: 24,
    md: 40,
    lg: 64,
    xl: 80
  };
  return /* @__PURE__ */ jsx("div", { style: loaderStyles({ size: sizes[size], center }), children: /* @__PURE__ */ jsx(Animation, { width: sizes[size], height: sizes[size], data }) });
}
export {
  Loader
};
